// extracted by mini-css-extract-plugin
export default {"instruction":"FormInstruction-module__instruction___dtbFp"};